import styled from "react-emotion";
import {Control, Label} from "bloomer";

export const InformationCard = styled("div")`
  border: 1px solid lightgrey;
  border-radius: 5px;
  padding: 10px 10px 2px 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
`;

export const AudioContainer = styled("div")`
  display: inline-block;
  flex-grow: 1;
`;

export const DownloadButtonContainer = styled("div")`
  display: inline-block;
  width: 200px;
  text-align: right;
`;

export const InputControl = styled(Control)`
  display: inline-block;
`;

export const SelectInputControl = styled(Control)`
  display: inline-block;
  width: 350px;
`;

export const InputWarning = styled("div")`
  text-align: left;
  font-size: 14px;
  color: red;
  margin-left: 130px;
`;

export const AutoPlayLabel = styled("label")`
  font-size: 16px;
  cursor: pointer;
  user-select: none;
`;

export const TextInputWarning = styled("span")`
  text-align: left;
  font-size: 14px;
  color: red;
`;

export const TextInputWarningsContainer = styled("div")`
  min-height: 30px;
`;

export const SelectField = styled("select")`
  width: 100%;
`;

export const SelectOption = styled("option")`
  width: 100%;
`;

export const InputLabel = styled(Label)`
  display: inline-block;
  text-align: left;
  width: 130px;
`;

export const InputRangeValue = styled("div")`
  display: inline-block;
  margin: 0px 10px;
  font-size: 16px;
  font-weight: bold;
  vertical-align: top;
`;

export const RangeInput = styled("input")`
  width: 280px;
  cursor: pointer;
`;

export const CharactersCountLabel = styled(Label)`
  float: right;
  font-weight: normal;
  font-size: 14px;
  line-height: 30px;
`;

export const ErrorMessage = styled("div")`
  text-align: left;
  margin-top: 10px;
  font-size: 16px;
  color: red;
`;


// WEBPACK FOOTER //
// ./src/components/model/TextToSpeech/TextToSpeechStyledComponents.tsx